import { render, staticRenderFns } from "./cModalReporteIngreso.vue?vue&type=template&id=2a3655b4&scoped=true"
import script from "./cModalReporteIngreso.vue?vue&type=script&lang=js"
export * from "./cModalReporteIngreso.vue?vue&type=script&lang=js"
import style0 from "./cModalReporteIngreso.vue?vue&type=style&index=0&id=2a3655b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3655b4",
  null
  
)

export default component.exports